export const MOBILE_BREAKPOINT = 450;
export const TABLET_BREAKPOINT = 820;
export const DESKTOP_BREAKPOINT = 1280;
